/* unplugin-vue-components disabled */import script from "./overviewPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./overviewPanel.vue?vue&type=script&setup=true&lang=js"

import "./overviewPanel.vue?vue&type=style&index=0&id=10c06c1f&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10c06c1f"]])

export default __exports__